import { create } from 'apisauce'
// import Router from '../router'; 

const api = create({
    baseURL: `${process.env.VUE_APP_BACKEND}`,
})

api.addRequestTransform(request => {
    const token = localStorage.getItem('token')
    if (token) {
        request.headers.Authorization = token
    }
})

api.axiosInstance.interceptors.response.use(response => {
    // 2xx response 
    return response;
}, function (error) {
    // not 2xx response
    if (error.response.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('roles');
        window.location.reload()
    }
    return Promise.reject(error);
});


export default api
